module.exports = __webpack_public_path__ + "static/media/63.529b8997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/63.jpg
// module id = 596
// module chunks = 0